import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

export interface AppConfig {
  apiUrl: string;
  apiServiceUrl: string;
  apiDownloadAllUrl: string;
  apiGetParcelUrl: string;
  apiUploadUrl: string;
  apiMsgUrl: string;
  apiElasticSearch: string;
  googleApiKey: string;
  googleTagManagerId: string;
}

@Injectable({ providedIn: "root" })
export class ConfigService {
  private config: AppConfig;

  constructor(private readonly http: HttpClient) {}

  /**
   * Called by APP_INITIALIZER before the app bootstraps.
   * Fetches /assets/config.json and patches the environment object so all
   * existing services that import environment continue to work unchanged.
   */
  load(): Promise<void> {
    return this.http
      .get<AppConfig>("/assets/config.json")
      .toPromise()
      .then((cfg) => {
        this.config = cfg;

        // Patch the shared environment object in place so all services
        // that import environment directly pick up the runtime values.
        environment.api.url = cfg.apiUrl;
        environment.api.serviceurl = cfg.apiServiceUrl;
        environment.api.downloadAllUrl = cfg.apiDownloadAllUrl;
        environment.api.getParcelUrl = cfg.apiGetParcelUrl;
        environment.api.uploadUrl = cfg.apiUploadUrl;
        environment.api.msgUrl = cfg.apiMsgUrl;
        environment.api.elasticSearch = cfg.apiElasticSearch;
        environment.googleApiKey = cfg.googleApiKey;
        environment.googleTagManagerId = cfg.googleTagManagerId;
      })
      .catch((err) => {
        console.error("Failed to load config.json", err);
      });
  }

  get<K extends keyof AppConfig>(key: K): AppConfig[K] {
    return this.config ? this.config[key] : null;
  }
}
